import React,{PureComponent} from 'react';
import {connect} from 'react-redux';

import AuthAppView from './AuthAppView';
import {authoriseApp} from 'actions';

class AuthApp extends PureComponent{
    onAuthoriseApp=()=>{
        this.props.authoriseApp(this.props.query)
    }
    onCancel=()=>{
        window.location = `${this.props.query.redirect_uri}?error=access_denied&state=${this.props.query.state}`;
    }
    render(){
        return <AuthAppView 
                    authApp={this.props.authApp}
                    user={this.props.user}
                    onAuthoriseApp={this.onAuthoriseApp}
                    onCancel={this.onCancel}/>
    }
}

function mapStateToProps(state){
    return{
        authApp:state.authorise.authApp,
        user:state.user.fullName,
    }
}

export default connect(mapStateToProps,{authoriseApp})(AuthApp)


// WEBPACK FOOTER //
// ./src/components/AuthApp/index.js